import { defineComponent, defineAsyncComponent, ref, computed, watch, onBeforeMount, createElementBlock, openBlock, createVNode, mergeProps, createSlots, withCtx, createBlock, createElementVNode, onMounted, createTextVNode, toDisplayString, mergeModels, useModel } from "vue";
import { QInput, QIcon, QDialog, QSelect, QChip, QBtn } from "quasar";
import { registerEntityEndpoint, getClient, BfBrandIcon, useNotificationStore, CMSNotification, SEARCH_DEBOUNCE } from "@editor/ui-utils";
import { useI18n } from "vue-i18n";
import { BrandList } from "@database/common-schema";
const ChannelModelName = "Channels";
const ChannelService = registerEntityEndpoint(ChannelModelName);
const { listEntities, getEntity, postEntity, putEntity, deleteEntity } = ChannelService;
const getChannels = async (search, options = {}) => {
  return listEntities({ params: { search, ...options } });
};
const getChannel = async (id) => {
  return getEntity(id);
};
const loadMainChannels = async (parameters) => {
  return listEntities({
    params: {
      ...parameters,
      isRootChannel: true
    }
  });
};
const getSubChannels = async (parentUuid, parameters) => {
  return listEntities({
    params: {
      ...parameters,
      parentUuid
    }
  });
};
const postChannel = async (channel) => await postEntity(channel);
const putChannel = async (channel) => await putEntity(channel._id, channel);
const deleteChannel = async (channelUuid) => await deleteEntity(channelUuid);
const fetchChannelDepth = async (id) => {
  return (await getClient().get(`/cms/channels/depth/${id}`)).data;
};
const getDefaultStateChannel = () => ({
  type: "CHANNEL",
  brand: "bunte",
  title: "",
  metaTitle: "",
  metaDescription: "",
  bfJobId: void 0,
  parentUuid: void 0,
  isRootChannel: false,
  isAdsEnabled: true,
  isEnabled: false,
  tags: [],
  breadcrumb: [],
  paths: [],
  hasDefaultSettings: true,
  blocks: []
});
const updateLegacyMigration = async (channelUuid, data) => {
  const client = getClient();
  const response = await client.put(`/cms/channels/${channelUuid}/legacy-migration`, data);
  return response.data;
};
const checkChannelArticles = async (channelUuid) => {
  const client = getClient();
  const response = await client.get(`/cms/channels/check-articles/${channelUuid}`);
  return response.data && !response.data.hasPublishedArticles;
};
const formatBreadcrumb = (breadcrumb, fallback) => {
  if (!breadcrumb || breadcrumb.length <= 1) {
    return fallback || "";
  }
  return breadcrumb.slice(1).map((b) => b.title).join(" > ");
};
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "channel-list.selector",
  props: {
    modelValue: { type: String, required: false, default: "" },
    label: { type: String, required: false, default: void 0 },
    disabled: { type: Boolean, required: false, default: false },
    required: { type: Boolean, required: false, default: false },
    brand: { type: String, required: false, default: void 0 },
    disableBrand: { type: Boolean, required: false },
    isBrandPrefilled: { type: Boolean, required: false, default: false },
    isHomepageChannelHidden: { type: Boolean, required: false, default: false }
  },
  emits: ["update:modelValue", "update:brand", "update:channel"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const ChannelList2 = defineAsyncComponent(() => import("./channel-list-Csn-HWiF.js"));
    const { t } = useI18n();
    const props = __props;
    const emit = __emit;
    const dialogVisible = ref(false);
    const channelData = ref({ brand: "" });
    const channelSelected = (channel) => {
      channelData.value = channel || { brand: "", title: "" };
      emit("update:modelValue", channel == null ? void 0 : channel._id);
      emit("update:brand", (channel == null ? void 0 : channel.brand) || "");
      emit("update:channel", channel);
      dialogVisible.value = false;
    };
    const tLabel = computed(() => !props.label ? t("components.channelSelectorLabel") : props.label);
    const displayValue = computed(() => formatBreadcrumb(channelData.value.breadcrumb, channelData.value.title));
    const clearChannelData = () => {
      channelData.value = { brand: "", title: "", _id: void 0 };
      emit("update:modelValue", channelData.value._id);
      emit("update:brand", "");
      emit("update:channel");
    };
    const resetChannelData = async () => {
      channelData.value = await getChannel(props.modelValue);
    };
    __expose({ resetChannelData });
    watch(
      () => props.modelValue,
      async () => {
        if (props.modelValue) {
          channelData.value = await getChannel(props.modelValue);
          emit("update:brand", channelData.value.brand);
        } else {
          clearChannelData();
        }
      },
      { deep: true }
    );
    onBeforeMount(async () => {
      if (props.modelValue) {
        channelData.value = await getChannel(props.modelValue);
      }
    });
    const __returned__ = { ChannelList: ChannelList2, t, props, emit, dialogVisible, channelData, channelSelected, tLabel, displayValue, clearChannelData, resetChannelData, get BfBrandIcon() {
      return BfBrandIcon;
    }, get QDialog() {
      return QDialog;
    }, get QIcon() {
      return QIcon;
    }, get QInput() {
      return QInput;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _hoisted_1$1 = { class: "q-icon" };
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    createVNode($setup["QInput"], mergeProps({
      modelValue: $setup.displayValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.displayValue = $event),
      "data-qa-channel-parent-input-field": "",
      class: $props.required && "required",
      disabled: $props.disabled,
      label: $setup.tLabel,
      "background-color": "white",
      clearable: "",
      outlined: "",
      dense: "",
      readonly: ""
    }, _ctx.$attrs, {
      onClick: _cache[1] || (_cache[1] = ($event) => $setup.dialogVisible = true),
      "onClick:clear": _cache[2] || (_cache[2] = ($event) => $setup.channelSelected(void 0)),
      "onClick:append": _cache[3] || (_cache[3] = ($event) => $setup.dialogVisible = true)
    }), createSlots({
      append: withCtx(() => [
        !$setup.channelData.title ? (openBlock(), createBlock($setup["QIcon"], {
          key: 0,
          name: "external-link"
        })) : (openBlock(), createBlock($setup["QIcon"], {
          key: 1,
          name: "clear",
          onClick: $setup.clearChannelData
        }))
      ]),
      _: 2
      /* DYNAMIC */
    }, [
      $setup.channelData.brand ? {
        name: "prepend",
        fn: withCtx(() => [
          createElementVNode("span", _hoisted_1$1, [
            createVNode($setup["BfBrandIcon"], {
              brand: $setup.channelData.brand
            }, null, 8, ["brand"])
          ])
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["modelValue", "class", "disabled", "label"]),
    createVNode($setup["QDialog"], {
      modelValue: $setup.dialogVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => $setup.dialogVisible = $event),
      "data-qa-channel-modal": "",
      "full-width": "",
      "full-height": "",
      onHide: _cache[7] || (_cache[7] = ($event) => $setup.dialogVisible = false)
    }, {
      default: withCtx(() => [
        createVNode($setup["ChannelList"], {
          brand: $props.brand,
          dialog: true,
          "filter-id": $setup.channelData._id,
          "show-new-button": false,
          "disable-brand": $props.disableBrand,
          "is-brand-prefilled": $props.isBrandPrefilled,
          "is-homepage-channel-hidden": $props.isHomepageChannelHidden,
          onClose: _cache[4] || (_cache[4] = ($event) => $setup.dialogVisible = false),
          "onClick:channel": $setup.channelSelected,
          "onBack:modal": _cache[5] || (_cache[5] = ($event) => $setup.dialogVisible = false)
        }, null, 8, ["brand", "filter-id", "disable-brand", "is-brand-prefilled", "is-homepage-channel-hidden"])
      ]),
      _: 1
      /* STABLE */
    }, 8, ["modelValue"])
  ]);
}
const channelList_selector = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__scopeId", "data-v-9e22bb2a"], ["__file", "/builds/CT/content-technology-framework/modules/channel/editor-ui-components/src/selectors/channel-list.selector.vue"]]);
const PAGE_SIZE = 50;
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "channel-selector",
  props: {
    search: { type: String, required: false },
    brand: { type: String, required: false },
    modelValue: { type: Array, required: false },
    mainChannel: { type: String, required: true },
    isHomepageChannelHidden: { type: Boolean, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const { t } = useI18n();
    const emit = __emit;
    const props = __props;
    const notificationStore = useNotificationStore();
    const filteredDisplayedOptions = ref([]);
    const channelMultiSelect = ref();
    const reachedPage = ref(1);
    const hasMoreData = ref(true);
    const searchedText = ref("");
    const previewOptions = computed(() => {
      if (!props.mainChannel)
        return [];
      return filteredDisplayedOptions.value.filter((channel) => channel._id !== props.mainChannel).map((channel) => {
        var _a;
        let breadcrumb = channel.breadcrumb;
        if ((channel.breadcrumbLength ?? 0) > 1) {
          breadcrumb = (_a = channel.breadcrumb) == null ? void 0 : _a.slice(1);
        }
        return {
          // Join all breadcrumb titles with a separator (e.g., ">")
          label: (breadcrumb == null ? void 0 : breadcrumb.map((b) => b.title).join(" > ")) || "",
          value: channel._id
        };
      });
    });
    const updateHasMoreDataFlag = (list) => {
      if (list.length < PAGE_SIZE) {
        hasMoreData.value = false;
      } else {
        hasMoreData.value = true;
      }
    };
    const getChannelSearchParams = (brand, page = 1) => {
      return {
        searchfields: ["title"],
        brand,
        isEnabled: true,
        sortBy: "breadcrumbLength",
        size: PAGE_SIZE,
        page,
        isRootChannel: props.isHomepageChannelHidden ? false : void 0
      };
    };
    const getEntityLabelById = async (id) => {
      const channel = filteredDisplayedOptions.value.find((channel2) => channel2._id === id);
      if (!channel) {
        try {
          const channel2 = await getChannel(id);
          filteredDisplayedOptions.value.push(channel2);
        } catch (error) {
          notificationStore.showNotification(new CMSNotification(t("channels.errorFailedLoadChannel", { id })));
        }
      }
      return channel ? channel.title : "";
    };
    const filteredOptions = (search, update) => {
      update(async () => {
        reachedPage.value = 1;
        const response = await getChannels(search, getChannelSearchParams(props.brand));
        const { list } = response;
        updateHasMoreDataFlag(list);
        filteredDisplayedOptions.value = list;
      });
    };
    const clearSearchText = () => {
      var _a;
      (_a = channelMultiSelect.value) == null ? void 0 : _a.updateInputValue("");
    };
    const inputBasedAdd = (_inputValue, done) => {
      done();
      clearSearchText();
    };
    const model = computed({
      get() {
        return props.modelValue ?? [];
      },
      set(channelUuid = []) {
        const setModel = channelUuid.map((channel) => {
          if (typeof channel === "object")
            return channel.value;
          return channel;
        }) ?? [];
        emit("update:modelValue", setModel);
      }
    });
    const loadMoreOptions = async ({ to, index }) => {
      const reachedEndOfDropdown = to === index;
      if (reachedEndOfDropdown && hasMoreData.value) {
        reachedPage.value += 1;
        const response = await getChannels(searchedText.value, getChannelSearchParams(props.brand, reachedPage.value));
        const { list } = response;
        updateHasMoreDataFlag(list);
        filteredDisplayedOptions.value.push(...list);
      }
    };
    watch([() => props.brand, () => props.mainChannel], async ([newBrand, _newMainChannel], [oldBrand]) => {
      reachedPage.value = 1;
      const response = await getChannels(props.search, getChannelSearchParams(newBrand));
      const { list } = response;
      updateHasMoreDataFlag(list);
      const isNewArticleInitialLoad = oldBrand === void 0 && newBrand === void 0;
      const isExistingArticleBrandChange = oldBrand && newBrand && [...BrandList].includes(newBrand) && oldBrand !== newBrand;
      const isExistingArticleInitialLoad = oldBrand === void 0 && newBrand && [...BrandList].includes(newBrand);
      if (isNewArticleInitialLoad || isExistingArticleBrandChange) {
        emit("update:modelValue", []);
        filteredDisplayedOptions.value = list;
      } else if (!isExistingArticleInitialLoad) {
        const mainChannelFilteredSecChannels = (props.modelValue ?? []).filter((secondaryChannel) => secondaryChannel !== _newMainChannel);
        emit("update:modelValue", mainChannelFilteredSecChannels);
        filteredDisplayedOptions.value = list;
      }
    });
    onMounted(async () => {
      if (props.brand) {
        reachedPage.value = 1;
        const response = await getChannels(props.search, getChannelSearchParams(props.brand));
        const { list } = response;
        updateHasMoreDataFlag(list);
        filteredDisplayedOptions.value = list;
      }
    });
    const __returned__ = { t, emit, props, notificationStore, filteredDisplayedOptions, channelMultiSelect, reachedPage, hasMoreData, searchedText, PAGE_SIZE, previewOptions, updateHasMoreDataFlag, getChannelSearchParams, getEntityLabelById, filteredOptions, clearSearchText, inputBasedAdd, model, loadMoreOptions, get SEARCH_DEBOUNCE() {
      return SEARCH_DEBOUNCE;
    }, get QChip() {
      return QChip;
    }, get QSelect() {
      return QSelect;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QSelect"], {
    ref: "channelMultiSelect",
    modelValue: $setup.model,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.model = $event),
    outlined: "",
    dense: "",
    label: $setup.t("channels.secondaryChannels"),
    options: $setup.previewOptions,
    "new-value-mode": "add-unique",
    "data-qa-channel-secondary-selector": "",
    "use-input": "",
    multiple: "",
    "map-options": "",
    "input-debounce": $setup.SEARCH_DEBOUNCE,
    "dropdown-icon": "expand_more",
    onFilter: $setup.filteredOptions,
    onAdd: $setup.clearSearchText,
    onNewValue: $setup.inputBasedAdd,
    onInputValue: _cache[1] || (_cache[1] = (search) => $setup.searchedText = search),
    onVirtualScroll: $setup.loadMoreOptions
  }, {
    "selected-item": withCtx((scope) => [
      createVNode($setup["QChip"], {
        "data-qa-secondary-channel-chip": scope.index,
        removable: "",
        dense: "",
        color: "cyan-1",
        tabindex: scope.tabindex,
        "text-color": "dark",
        onRemove: ($event) => scope.removeAtIndex(scope.index)
      }, {
        default: withCtx(() => [
          createTextVNode(
            toDisplayString(scope.opt.label && scope.opt.label.split(" > ").pop() || $setup.getEntityLabelById(scope.opt)),
            1
            /* TEXT */
          )
        ]),
        _: 2
        /* DYNAMIC */
      }, 1032, ["data-qa-secondary-channel-chip", "tabindex", "onRemove"])
    ]),
    _: 1
    /* STABLE */
  }, 8, ["modelValue", "label", "options", "input-debounce"]);
}
const channelSelector = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__file", "/builds/CT/content-technology-framework/modules/channel/editor-ui-components/src/selectors/channel-selector.vue"]]);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "multiple-channel-list-selector",
  props: /* @__PURE__ */ mergeModels({
    label: { type: String, required: true },
    brand: { type: String, required: false },
    maxSelection: { type: Number, required: false },
    disable: { type: Boolean, required: false }
  }, {
    "modelValue": { type: Array, ...{ default: [] } },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const ChannelList2 = defineAsyncComponent(() => import("./channel-list-Csn-HWiF.js"));
    const { t } = useI18n();
    const props = __props;
    const model = useModel(__props, "modelValue");
    const dialogVisible = ref(false);
    const selectedChannels = ref([]);
    const handleChannelClick = (clickedChannel) => {
      const isChannelSelected = selectedChannels.value.find((channel) => channel._id === clickedChannel._id);
      if (isChannelSelected) {
        selectedChannels.value = selectedChannels.value.filter((channel) => channel._id !== clickedChannel._id);
      } else {
        selectedChannels.value.push(clickedChannel);
      }
      if (props.maxSelection && selectedChannels.value.length > props.maxSelection) {
        selectedChannels.value = selectedChannels.value.slice(props.maxSelection * -1);
      }
    };
    const addSelectedChannel = () => {
      const selectedChannelUuids = selectedChannels.value.map((channel) => channel._id);
      model.value = [...selectedChannelUuids];
      dialogVisible.value = false;
    };
    const closeDialog = () => {
      selectedChannels.value = [];
      dialogVisible.value = false;
    };
    const removeChannel = (id) => {
      var _a;
      const index = (_a = model.value) == null ? void 0 : _a.indexOf(id);
      if (index !== -1) {
        model.value.splice(index, 1);
      }
    };
    const fetchSelectedChannels = async () => {
      if (!model.value.length)
        return;
      try {
        const { list } = await getChannels(void 0, { uuids: model.value });
        selectedChannels.value = list;
      } catch (error) {
        console.error(error);
      }
    };
    watch(
      () => dialogVisible.value,
      async (dialogVisible2) => {
        if (!dialogVisible2)
          return;
        await fetchSelectedChannels();
      }
    );
    onBeforeMount(fetchSelectedChannels);
    const __returned__ = { ChannelList: ChannelList2, t, props, model, dialogVisible, selectedChannels, handleChannelClick, addSelectedChannel, closeDialog, removeChannel, fetchSelectedChannels, get BfBrandIcon() {
      return BfBrandIcon;
    }, get QBtn() {
      return QBtn;
    }, get QChip() {
      return QChip;
    }, get QDialog() {
      return QDialog;
    }, get QIcon() {
      return QIcon;
    }, get QSelect() {
      return QSelect;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1 = { class: "red-color" };
const _hoisted_2 = { class: "q-icon" };
const _hoisted_3 = { class: "dialog-footer q-pa-md" };
const _hoisted_4 = { class: "col" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createVNode($setup["QSelect"], {
      modelValue: $setup.model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.model = $event),
      label: $props.label,
      outlined: "",
      dense: "",
      multiple: "",
      chips: "",
      options: $setup.selectedChannels,
      disable: $props.disable,
      "hide-dropdown-icon": "",
      class: "q-field--with-bottom",
      "emit-value": "",
      "use-input": "",
      "map-options": "",
      "option-value": "_id",
      "option-label": "title",
      readonly: "",
      clearable: "",
      "data-qa-multiple-channel-selector-field": "",
      onClick: _cache[1] || (_cache[1] = ($event) => $setup.dialogVisible = true)
    }, createSlots({
      "selected-item": withCtx(({ opt, toggleOption }) => [
        createVNode($setup["QChip"], {
          color: "cyan-1",
          "text-color": "dark",
          removable: "",
          disable: $props.disable,
          onRemove: ($event) => $setup.removeChannel((opt == null ? void 0 : opt._id) ?? opt),
          onClick: ($event) => toggleOption(opt)
        }, {
          default: withCtx(() => [
            createTextVNode(
              toDisplayString(opt.title),
              1
              /* TEXT */
            )
          ]),
          _: 2
          /* DYNAMIC */
        }, 1032, ["disable", "onRemove", "onClick"])
      ]),
      append: withCtx(() => [
        createVNode($setup["QIcon"], { name: "external-link" })
      ]),
      _: 2
      /* DYNAMIC */
    }, [
      $props.brand ? {
        name: "prepend",
        fn: withCtx(() => [
          createElementVNode("span", _hoisted_2, [
            createVNode($setup["BfBrandIcon"], { brand: $props.brand }, null, 8, ["brand"])
          ])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["modelValue", "label", "options", "disable"]),
    createVNode($setup["QDialog"], {
      modelValue: $setup.dialogVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => $setup.dialogVisible = $event),
      "data-qa-channel-modal": "",
      "full-width": "",
      "full-height": "",
      class: "channel-list-selector",
      onHide: $setup.closeDialog
    }, {
      default: withCtx(() => [
        createVNode($setup["ChannelList"], {
          selectedChannels: $setup.selectedChannels,
          "onUpdate:selectedChannels": _cache[2] || (_cache[2] = ($event) => $setup.selectedChannels = $event),
          brand: $props.brand,
          "show-new-button": false,
          selection: "multiple",
          dialog: "",
          "disable-brand": "",
          "is-brand-prefilled": "",
          "is-homepage-channel-hidden": "",
          onClose: _cache[3] || (_cache[3] = ($event) => $setup.dialogVisible = false),
          "onClick:channel": $setup.handleChannelClick,
          "onBack:modal": _cache[4] || (_cache[4] = ($event) => $setup.dialogVisible = false)
        }, {
          footer: withCtx(() => [
            createElementVNode("div", _hoisted_3, [
              createElementVNode("div", _hoisted_4, [
                createVNode($setup["QBtn"], {
                  color: "primary",
                  icon: "send",
                  class: "q-mr-sm",
                  label: $setup.t("channels.addSelectedChannels"),
                  "data-qa-channels-add-selector-button": "",
                  onClick: $setup.addSelectedChannel
                }, null, 8, ["label"]),
                createVNode($setup["QBtn"], {
                  "text-color": "secondary",
                  icon: "close",
                  color: "primary",
                  class: "q-mr-sm bg-white",
                  label: $setup.t("articles.cancelButton"),
                  "data-qa-channels-cancel-selector-button": "",
                  onClick: $setup.closeDialog
                }, null, 8, ["label"])
              ])
            ])
          ]),
          _: 1
          /* STABLE */
        }, 8, ["selectedChannels", "brand"])
      ]),
      _: 1
      /* STABLE */
    }, 8, ["modelValue"])
  ]);
}
const multipleChannelListSelector = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-aac3a386"], ["__file", "/builds/CT/content-technology-framework/modules/channel/editor-ui-components/src/selectors/multiple-channel-list-selector.vue"]]);
const ChannelList = defineAsyncComponent(() => import("./channel-list-Csn-HWiF.js"));
const getChannelListComponent = () => import("./channel-list-Csn-HWiF.js");
const channelComponentsModule = {
  routes: [],
  messages: {
    en: {},
    de: {}
  }
};
export {
  ChannelService as C,
  _export_sfc as _,
  ChannelList as a,
  getChannelListComponent as b,
  channelComponentsModule as c,
  channelList_selector as d,
  channelSelector as e,
  ChannelModelName as f,
  getSubChannels as g,
  getChannels as h,
  getChannel as i,
  putChannel as j,
  deleteChannel as k,
  loadMainChannels as l,
  multipleChannelListSelector as m,
  fetchChannelDepth as n,
  getDefaultStateChannel as o,
  postChannel as p,
  checkChannelArticles as q,
  formatBreadcrumb as r,
  updateLegacyMigration as u
};
//# sourceMappingURL=index-BZFQWuyj.js.map
